<template>
<Layout>
  <div class="section  content is-size-7">
    <p>หากคุณยกเลิกการสมัครคุณจะถูกริบค่าธรรมเนียมการสมัครสมาชิกที่เหลืออยู่</p>
    <br>
    <p><input type="numer" class="input is-fullwidth" placeholder="รูปแบบหมายเลขโทรศัพท์: 700600500" /></p><br>
    <p><input type="submit" class="button" value=" ตกลง " /></p>
    <p>หากต้องการยกเลิกการเป็นสมาชิกคุณสามารถส่งอีเมลไปที่ cuca@778mobile.com.</p>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Deactivation',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/TH/Deactivation.vue